export const NAME_APPLICATION = "PANEL_SIMULADOSETEC";
export const API_KEY_FIREBASE = "AIzaSyCvs_3SRpLABSozjPKQSp5fwwEGMm3oft8";
export const URL_BASE_DATABASE_FIREBASE = "https://project-simulados-etec-default-rtdb.firebaseio.com/";